import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { I18nProvider } from './i18n'
import { ThemeProvider, applyTheme, readStoredTheme, resolveTheme } from './lib/theme'
import { registerServiceWorker } from './lib/pwa'
import { captureReferralCode } from './lib/referral'
import './index.css'

// A shared link may land on any route before auth redirects to sign-up. Capture
// its attribution before the router changes the address.
captureReferralCode()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Balances, prices and orders arrive over the websocket, so polling is a
      // fallback rather than the primary update path.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root container #root is missing from index.html')
}

// Paint the chosen theme before the first frame so a light-theme user never
// sees a black flash.
applyTheme(resolveTheme(readStoredTheme()))

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
    <I18nProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </I18nProvider>
    </ThemeProvider>
  </StrictMode>,
)

void registerServiceWorker()
